import { Link, Stack } from 'expo-router';
import { StyleSheet, Text, View } from 'react-native';
import { useTheme, SPACING, TYPOGRAPHY, withWeight } from '../src/theme';

export default function NotFoundScreen() {
  const { colors } = useTheme();
  return (
    <>
      <Stack.Screen options={{ title: 'Oops!' }} />
      <View style={[styles.container, { backgroundColor: colors.background }]}>
        <Text style={[styles.title, { color: colors.text }]}>{"This screen doesn't exist."}</Text>
        <Link href="/" style={styles.link}>
          <Text style={[styles.linkText, { color: colors.text }]}>Go to home screen</Text>
        </Link>
      </View>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: SPACING.lg,
  },
  title: {
    ...TYPOGRAPHY.screenTitle,
    textAlign: 'center',
  },
  link: {
    marginTop: SPACING.md,
    paddingVertical: SPACING.md,
  },
  // Ink, underlined: green here reads as a category word, not a link.
  linkText: {
    ...withWeight(TYPOGRAPHY.body, 'medium'),
    textDecorationLine: 'underline',
  },
});
